<template>
  <v-sheet>
    <v-row :id="gridId">
      <v-col>
        <div class="container">
          <base-badge
            v-for="(item, i) in items"
            v-bind:key="item.id"
            align-content="top"
            class="js-grid-item"
            :id="ids[i]"
            :badgeIcon="badgeIcons[i]"
            :badgeColor="badgeColors[i]"
            :secondaryBadgeIcon="secondaryBadgeIcons[i]"
            :completed="item.status"
            :item="item"
            :imageUrl="imageUrls[i]"
            :title="title(item)"
            :selected="selected[i]"
            v-on:badge:click="$emit('grid:badge:click', item)"
            v-on:badge:action:click="$emit('grid:badge:action:click', item)"
          ></base-badge>
          <slot></slot>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseBadge from "@/components/BaseBadge"

export default {
  mixins: [eventMixin],
  components: {
    BaseBadge
  },
  props: {
    badgeIcons: { type: Array, default: () => [] },
    badgeColors: { type: Array, default: () => [] },
    secondaryBadgeIcons: { type: Array, default: () => [] },
    ids: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    imageUrls: { type: Array, default: () => [] },
    selected: { type: Array, default: () => [] },
    gridId: { type: String, default: "" },
    showTitle: { type: Boolean, default: true }
  },
  methods: {
    title(item) {
      return this.showTitle ? item && item.name : ""
    }
  }
}
</script>

<style lang="scss" scoped>
div.container {
  display: flex;
  flex-wrap: wrap;
}
</style>
